//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'u8-rank-item',
  props: {
    percentage: {
      default: 0
    },
    currVal: {
      default: ''
    },
    title: {
      default: ''
    },
    desc: {
      default: ''
    },
    color: {
      default: '#2c6dd2'
    }
  }
};